import {Link, Outlet, useLocation} from 'react-router-dom'
import {isSuperAdmin, useAuth} from '../modules/auth'
import {findUnavailableFeature, normalizeFeaturePath} from './featureAvailability'

export function FeatureAvailabilityGuard() {
  const {permissions, featureCatalog} = useAuth()
  const location = useLocation()
  const managingPermissions = normalizeFeaturePath(location.pathname) === '/permissions'
  // Mantém o ponto de recuperação disponível ao superadministrador, inclusive
  // quando todas as permissões de negócio estiverem desativadas.
  const unavailable =
    managingPermissions && isSuperAdmin()
      ? undefined
      : findUnavailableFeature(location.pathname, featureCatalog, permissions)
  const denied = managingPermissions && !isSuperAdmin()
  if (unavailable || denied) {
    return (
      <div
        role='alert'
        className='mx-auto my-12 max-w-lg rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm'
      >
        <h1 className='text-lg font-bold text-gray-900'>
          {unavailable ? 'Feature desativada' : 'Acesso indisponível'}
        </h1>
        <p className='mt-3 text-sm text-gray-600'>
          {unavailable
            ? `A permissão “${unavailable.title}” está inativa no sistema.`
            : 'Seu perfil não pode gerenciar as permissões do sistema.'}
        </p>
        <Link to='/home' className='text-sm font-semibold text-blue-600'>
          Voltar ao início
        </Link>
      </div>
    )
  }
  return <Outlet />
}
